import React from 'react'
import { ModalBody } from 'reactstrap'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import ReportingGroupDetailFormContent from '@/internal-app/pages/reportingGroups/reportingGroupDetailFormContent'

class AddNewReportingGroupDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      id: 0,
      name: '',
      reportingCycle: null,
      templates: [],
      submissionWorkflow: null,
      imposeFineWorkflow: null
    }
  }
  saveChanges = () => {
    this.props.onAction({ ...this.state, forecasting: this.props.forecasting })
  }
  render () {
    const { localize, localizeProps, forecasting } = this.props
    return (
      <ValidationBoundary>
        <BasicHeader title={forecasting ? 'Reporting.ForecastingReportingGroup' : 'Reporting.ReportingGroup'} {...this.props} />
        <ModalBody>
          <ErrorBoundary>
            <ReportingGroupDetailFormContent
              {...this.state}
              onChange={value => this.setState(value)}
              localize={localize}
              localizeProps={localizeProps}
            />
          </ErrorBoundary>
        </ModalBody>
        <ValidationState render={({ isValid }) =>
          <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...this.props} onAction={this.saveChanges} disabled={!isValid} />
        } />
      </ValidationBoundary>
    )
  }
}

export default {
  component: AddNewReportingGroupDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/addNewReportingGroup.js